var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckmark = function SvgCheckmark(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C6EAE4",
    d: "M27.201 46.83l35.844-35.843A9.5 9.5 0 1 1 76.48 24.422L32.823 68.079a9.493 9.493 0 0 1-2.876 2.555 9.524 9.524 0 0 1-13.01-3.486L.961 39.476a9.524 9.524 0 0 1 16.496-9.524L27.2 46.83z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.242,
    cy: 34.962,
    fill: "#8ED6C9",
    rx: 9.563,
    ry: 9.524,
    transform: "rotate(-120 9.242 34.962)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmark);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCIgdmlld0JveD0iMCAwIDgwIDgwIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGZpbGw9IiNDNkVBRTQiIGQ9Ik0yNy4yMDEgNDYuODNsMzUuODQ0LTM1Ljg0M0E5LjUgOS41IDAgMSAxIDc2LjQ4IDI0LjQyMkwzMi44MjMgNjguMDc5YTkuNDkzIDkuNDkzIDAgMCAxLTIuODc2IDIuNTU1IDkuNTI0IDkuNTI0IDAgMCAxLTEzLjAxLTMuNDg2TC45NjEgMzkuNDc2YTkuNTI0IDkuNTI0IDAgMCAxIDE2LjQ5Ni05LjUyNEwyNy4yIDQ2LjgzeiIvPjxlbGxpcHNlIGN4PSI5LjI0MiIgY3k9IjM0Ljk2MiIgZmlsbD0iIzhFRDZDOSIgcng9IjkuNTYzIiByeT0iOS41MjQiIHRyYW5zZm9ybT0icm90YXRlKC0xMjAgOS4yNDIgMzQuOTYyKSIvPjwvZz48L3N2Zz4=";